import React, { Component } from "react";

// Components
import UploadProgress from "./UploadProgress";

// CSS
import "../../css/forms/dropzone-automatic-upload-file.css";

class DropzoneAutomaticFile extends Component {
	render() {
		const { file } = this.props;

		return (
			<div className="automatic-upload-file">
				<div className="file-info">{file.name}</div>
				{file.loading && (
					<React.Fragment>
						<UploadProgress completed={file.completed} message={file.message} />
						<div className="icon-spinner" />
					</React.Fragment>
				)}
			</div>
		);
	}
}

export default DropzoneAutomaticFile;



// WEBPACK FOOTER //
// ./src/components/utils/DropzoneAutomaticFile.js